import React from 'react';

import IngestorStatus from './IngestorStatus';
import ProcessorStatus from './ProcessorStatus';
import ExporterStatus from './ExporterStatus';
// @ts-ignore: side-effect style import is handled by the bundler
import './Lisa.scss';

export default function LisaDashboard() {
    return (
        <div className="lisa">
            <div className="lisa__header">
                <h1 className="lisa__title">LISA COMMUNICATION</h1>
            </div>

            <IngestorStatus />
            <ProcessorStatus />
            <ExporterStatus />
        </div>
    );
}
